import { Component } from '@angular/core';
import { C3Service } from '../../c3.service';

@Component({
    selector: 'app-state-select',
    //   changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './state-select.component.html',
    styleUrls: ['./state-select.component.css'],
    standalone: false
})
export class StateSelectComponent {
  private _c3Service: C3Service;
  private modelIds: Set<number> = new Set();

  public get states() {
    return this._c3Service.states;
  }
  public get selectedState() {
    if (this.modelSpecs.length > 0) {
      return this.modelSpecs[0].stateIdArray[0];
    }
    return 0;
  }

  public get modelSpecs(): any[] {
    const modelSpecs: any[] = [];
    this.modelIds.forEach((id) => {
      modelSpecs.push(this._c3Service._model[id].modelSpec);
    });
    return modelSpecs;
  }

  public constructor(c3Service: C3Service) {
    this._c3Service = c3Service;
    Object.entries(this._c3Service._model).forEach((model: any, id: number) => {
      this.modelIds.add(id);
    });
  }

  public selectedStateChanged(value: string) {
    if (value) {
      this.modelSpecs.forEach((modelSpec, index) => {
        const state = this._c3Service._model[index].modelDirectory.stateInfoArray.length;
        if (parseInt(value) - 1000 > state) {
          modelSpec.stateIdArray = [parseInt(state + 1000)];
        } else {
          modelSpec.stateIdArray = [parseInt(value)];
        }
      });
    }
  }
}
